/* kott-timeline
 *
 * Milestone carousel. Uses theme.Slideshow (and therefore Flickity) so RTL,
 * dragging and resize behave the same as every other carousel on the site.
 * The arrows live outside the carousel in the navigation row, so Flickity's
 * own buttons stay off and the markup's buttons drive it instead.
 */
(function () {
  var SECTION_TYPE = 'kott-timeline';

  function KottTimeline(container) {
    this.container = container;
    this.id = container.getAttribute('data-section-id');
    this.el = container.querySelector('#KottTimeline-' + this.id);
    this.slider = null;
    this.initialIndex = 0;

    if (!this.el) return;

    var slides = this.el.querySelectorAll('.kott-tl__slide');
    if (slides.length < 2) {
      if (slides[0]) slides[0].classList.add('is-selected');
      return;
    }

    this.slider = new theme.Slideshow(this.el, {
      fade: false,
      // centred so the previous and next milestones peek at both edges
      cellAlign: 'center',
      contain: false,
      wrapAround: true,
      pageDots: false,
      prevNextButtons: false,
      adaptiveHeight: false,
      setGallerySize: true,
      initialIndex: this.initialIndex
    });

    this.bindArrows();
    this.nudge();

    // The card's height settles late: the section stylesheet, web fonts and
    // lazy images all land after Flickity has taken its first measurement.
    // Re-measure whenever a card actually changes size rather than guessing
    // when that will be.
    if ('ResizeObserver' in window) {
      var self = this;
      this.observer = new ResizeObserver(function () { self.resizeSlider(); });
      [].forEach.call(this.el.querySelectorAll('.kott-tl__card'), function (card) {
        self.observer.observe(card);
      });
    }
  }

  KottTimeline.prototype = Object.assign({}, KottTimeline.prototype, {
    flickity: function () {
      return this.slider && this.slider.slideshow;
    },

    bindArrows: function () {
      var self = this;
      var prev = this.container.querySelector('[data-kott-tl-prev]');
      var next = this.container.querySelector('[data-kott-tl-next]');

      if (prev) {
        prev.addEventListener('click', function () {
          var f = self.flickity();
          if (f) f.previous();
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          var f = self.flickity();
          if (f) f.next();
        });
      }
    },

    // Card height comes partly from an aspect-ratio box and partly from the
    // artwork, so re-measure once layout settles and again as images land.
    nudge: function () {
      var self = this;
      requestAnimationFrame(function () {
        self.resizeSlider();
        requestAnimationFrame(function () {
          self.resizeSlider();
        });
      });

      [].slice.call(this.el.querySelectorAll('img')).forEach(function (img) {
        if (img.complete) return;
        img.addEventListener('load', function () {
          self.resizeSlider();
        }, { once: true });
      });
    },

    resizeSlider: function () {
      var f = this.flickity();

      // Flickity ignores resize() mid-animation or mid-drag, which would leave
      // the viewport at a stale height if a card grew during a slide change
      // (lazy images landing as the page scrolls). Wait for it to settle.
      if (f && (f.isAnimating || f.isDragging)) {
        if (!this.resizePending) {
          var self = this;
          this.resizePending = true;
          f.once('settle', function () {
            self.resizePending = false;
            self.resizeSlider();
          });
        }
        return;
      }

      this.equalizeHeights();
      if (this.slider && typeof this.slider.resize === 'function') {
        this.slider.resize();
      }
    },

    // The cards stack behind one another, so they have to share one height:
    // the tallest copy sets it for all. Applied to the text half rather than
    // the card so the mobile image/text seam (which the badge is pinned to)
    // stays where the image ratio puts it.
    equalizeHeights: function () {
      var texts = [].slice.call(this.el.querySelectorAll('.kott-tl__text'));
      var max = 0;
      texts.forEach(function (t) { t.style.minHeight = ''; });
      texts.forEach(function (t) { max = Math.max(max, t.offsetHeight); });
      texts.forEach(function (t) { t.style.minHeight = max + 'px'; });
    },

    forceReload: function () {
      this.onUnload();
      KottTimeline.call(this, this.container);
    },

    onUnload: function () {
      if (this.observer) this.observer.disconnect();
      this.observer = null;
      if (this.slider && typeof this.slider.destroy === 'function') {
        this.slider.destroy();
      }
      this.slider = null;
    },

    // Theme editor: jump to the milestone being edited.
    onBlockSelect: function (evt) {
      var slide = this.el.querySelector(
        '[data-shopify-editor-block*="' + evt.detail.blockId + '"]'
      ) || this.el.querySelectorAll('.kott-tl__slide')[0];
      if (!slide) return;
      var index = parseInt(slide.dataset.index, 10) || 0;
      var f = this.flickity();
      if (f) {
        f.select(index);
      } else {
        this.initialIndex = index;
      }
    }
  });

  function register() {
    if (!window.theme || !theme.sections || !theme.Slideshow) return false;
    theme.sections.register(SECTION_TYPE, KottTimeline);
    return true;
  }

  if (!register()) {
    document.addEventListener('DOMContentLoaded', function () {
      if (!register()) window.addEventListener('load', register);
    });
  }
})();
